import { __rest } from "tslib";
import React, { forwardRef, useCallback } from 'react';
import { SelectInput } from './styled';
import { withLabels } from '../../hoc';
export const Select = withLabels(forwardRef((_a, ref) => {
    var { className, options, value, onChange, size, disabled, hasError } = _a, otherProps = __rest(_a, ["className", "options", "value", "onChange", "size", "disabled", "hasError"]);
    const handleChange = useCallback((e) => {
        if (!onChange)
            return;
        onChange(e.currentTarget.value);
    }, [onChange]);
    return (React.createElement(SelectInput, Object.assign({ className: className, sizeVariant: size, value: value !== null && value !== void 0 ? value : undefined, onChange: handleChange, disabled: disabled, hasError: hasError, ref: ref }, otherProps), !!options &&
        options.map((option) => (React.createElement("option", { key: option.label, value: option.value, disabled: option.disabled }, option.label)))));
}));
Select.displayName = 'Select';
//# sourceMappingURL=Select.js.map